module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-3.e7e902ba.jpg";